import { createSelector } from 'reselect';

import type { State } from 'reducers';

export const selectVolunteersState = (state: State) => state.get('entities').volunteers;

export const selectVolunteers = createSelector(selectVolunteersState, (volunteersState) =>
  volunteersState.get('volunteers')
);

export const selectDisplayedVolunteers = createSelector(
  selectVolunteersState,
  selectVolunteers,
  (volunteersState, volunteers) =>
    volunteersState
      .get('displayedVolunteerIds')
      .map((volunteerId) => volunteerId && volunteers.get(volunteerId))
);

export const selectTotal = createSelector(selectVolunteersState, (volunteersState) =>
  volunteersState.get('total')
);

export const selectVolunteerById = createSelector(
  selectVolunteers,
  (_volunteers, volunteerId) => volunteerId,
  (volunteers, volunteerId) => volunteers.get(volunteerId)
);
